import * as yup from 'yup'
import 'yup-phone'
import { flightNumberValidation } from 'helpers/regexValidation'

const passenger = yup.object().shape({
  name: yup.string().nullable().label('Name'),
  email: yup.string().nullable().label('Email'),
  isLeadPassenger: yup.boolean().nullable(),
  contactNumber: yup
    .string()
    .nullable()
    .when('name', {
      is: (val: string) => val && val?.length > 0,
      then: yup.string().phone().label('Contact number'),
      otherwise: yup.string().nullable().label('Contact number'),
    })
    .label('Contact Number'),
  userId: yup.number().nullable().label('User ID'),
})

const bookingReference = yup.object().shape({
  isMandatory: yup.boolean(),
  value: yup
    .string()
    .test(
      'required',
      'Please enter a value for this reference',
      (value, context) => {
        if (context.parent.isMandatory) {
          if (value !== undefined && value.length > 0) {
            return true
          } else {
            return false
          }
        }
        return true
      },
    )
    .test(
      'matches',
      'Value does not meet the pattern requirements',
      (value, context) => {
        var re = new RegExp(context.parent.regex)
        return re.test(value ? value : '')
      },
    ),
})

const optionalFlightNumberSchema = yup
  .string()
  .nullable()
  .test(
    'flight-number-format',
    'Please enter a valid flight number',
    (value) => {
      const normalisedValue = value?.trim() ?? ''

      if (!normalisedValue) {
        return true
      }

      return flightNumberValidation.test(normalisedValue)
    },
  )

export default yup.object().shape({
  // clientId: yup.number().required().label('Client'),
  clientId: yup
    .number()
    .test('matches', 'Please select a valid client', (value) => {
      return value === 0 ? false : true
    }),
  passengers: yup.array().of(passenger).nullable(),
  bookingReferenceValues: yup.array().of(bookingReference).nullable(),
  outbound: yup.object().shape({
    flightDetails: yup.object().shape({
      flightNumber: optionalFlightNumberSchema,
    }),
  }),
  inbound: yup.object().shape({
    flightDetails: yup.object().shape({
      flightNumber: optionalFlightNumberSchema,
    }),
  }),
})
